import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Menu;
var _excluded = ["className"];
import { Fragment } from "react";
import Menu from "@crehana/icons/outline/Menu";
import { useIsClient } from "@crehana/react-hooks";
import cn from "classnames";
import { useMainMenuContext, useMainMenuTranslation } from "../../../../hooks";
import LeftMenuDrawer from "./LeftMenuDrawer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LeftMenuMobile = function LeftMenuMobile(_ref) {
  var className = _ref.className,
    leftMenuMobileProps = _objectWithoutProperties(_ref, _excluded);
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    onLeftMenuOpen = _useMainMenuContext.onLeftMenuOpen;
  var isClient = useIsClient();
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      "aria-label": t('OPEN_MENU'),
      name: t('LEFT_MENU_TITLE'),
      onClick: isClient ? onLeftMenuOpen : undefined,
      className: cn('left-menu-mobile w-24 h-32 flex items-center justify-center flex-shrink-0 mr-12 sm:mr-40', theme.nav.iconColorClassName, className),
      children: _Menu || (_Menu = /*#__PURE__*/_jsx(Menu, {
        size: 24,
        "aria-hidden": true,
        ignoreColor: true,
        className: "fill-current"
      }))
    }), /*#__PURE__*/_jsx(LeftMenuDrawer, _objectSpread({}, leftMenuMobileProps))]
  });
};
export default LeftMenuMobile;